// Sélectionner tous les boutons "Afficher plus"
var expandButtons = document.querySelectorAll('.read-more');

// Pour chaque bouton, ajouter un gestionnaire d'événement de clic
expandButtons.forEach(function(button) {
    button.addEventListener('click', function() {
        // Toggle la classe "expanded" sur le paragraphe parent
        var contentText = button.parentNode.querySelector('.slide-container--content_text');
        contentText.classList.toggle('expanded');
        
        // Modifier le texte du bouton
        if (contentText.classList.contains('expanded')) {
            button.textContent = 'Fermer';
        } else {
            button.textContent = 'Lire la suite';
        }
    });
});
